(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSModalidadController', SSModalidadController);

    SSModalidadController.$inject = ['SSModalidad'];

    function SSModalidadController(SSModalidad) {

        var vm = this;

        vm.sSModalidads = [];

        loadAll();

        function loadAll() {
            SSModalidad.query(function(result) {
                vm.sSModalidads = result;
                vm.searchQuery = null;
            });
        }
    }
})();
